<template>
  <div
    class="relative-position z-light" @click.capture="onClick" @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <el-select
      v-model="linkValue" placeholder="请选择" style="width: 120px"
      @change="onChange"
    >
      <el-option
        v-for="(ho, i) in hoverIconDefault" :key="i" :label="ho.label"
        :value="ho.value"
      />
    </el-select>
  </div>
</template>
<script>
export default {
  props: ['value', 'hoverIconDefault'],

  data() {
    return {
      linkValue: '',
    };
  },

  mounted() {
    this.linkValue = this.value;
  },

  methods: {
    onChange(val) {
      this.$emit('change', val);
    },
    onClick(e) {},
    onMouseEnter() {
      this.$emit('mouseenter', false);
    },
    onMouseLeave() {
      this.$emit('mouseleave', true);
    },
  },
};
</script>
